import config from './config';

export default {
  apiKey: config.bugsnag.apiKey,
  releaseStage: config.bugsnag.releaseStage,
  appVersion: config.app.version,
  enabledReleaseStages: ['production', 'prod', 'demo'],
};
